import moment, { Moment } from "moment";
import {
  EnumStatisticChartPeriod,
  EnumStatisticChartType,
  StatisticChartModel,
} from "../../../../../server/routes/statistic/types";

type ChartData = { [label in string]: number };

enum EnumGroupBy {
  DAY = "day",
  MONTH = "month",
}

const getLabel = (date: Moment, groupBy: EnumGroupBy): string => {
  switch (groupBy) {
    case EnumGroupBy.DAY:
      return date.format("DD.MM");
    case EnumGroupBy.MONTH:
      return date.format("MMMM, YY");
  }
};

const getGroupBy = <T extends EnumStatisticChartType>(
  data: StatisticChartModel<T>[],
  period: EnumStatisticChartPeriod
): EnumGroupBy => {
  switch (period) {
    case EnumStatisticChartPeriod.WEEK:
    case EnumStatisticChartPeriod.MONTH:
      return EnumGroupBy.DAY;
    case EnumStatisticChartPeriod.QUARTER:
    case EnumStatisticChartPeriod.YEAR:
      const { minDate, maxDate } = data.reduce<{
        minDate: Moment | undefined;
        maxDate: Moment | undefined;
      }>(
        ({ minDate, maxDate }, { date }) => {
          if (!minDate && !maxDate) {
            minDate = moment(date);
            maxDate = moment(date);
          } else {
            if (moment(date).diff(minDate) > 0) {
              minDate = moment(date);
            }
            if (moment(date).diff(maxDate) < 0) {
              maxDate = moment(date);
            }
          }

          return { minDate, maxDate };
        },
        { minDate: undefined, maxDate: undefined }
      );
      if (!minDate || !maxDate) {
        return EnumGroupBy.DAY;
      }
      if (minDate.diff(maxDate, "month") > 2) {
        return EnumGroupBy.MONTH;
      }
      return EnumGroupBy.DAY;
  }
};

const prepareChartData = <T extends EnumStatisticChartType>(
  charts: {
    data: StatisticChartModel<T>[];
    color:
      | "primary"
      | "secondary"
      | "error"
      | "warning"
      | "yandexMarket"
      | "wildberries"
      | "ozon"
      | "sber";
    marketplace: any;
  }[],
  period: EnumStatisticChartPeriod,
  type: T
): {
  data: ChartData;
  color:
    | "primary"
    | "secondary"
    | "error"
    | "warning"
    | "yandexMarket"
    | "wildberries"
    | "ozon"
    | "sber";
  marketplace: any;
}[] => {
  return charts.map(({ data, ...otherParams }) => {
    const chartData = Object.values(data).reduce<{
      [label in string]: Omit<StatisticChartModel<T>, "date">[];
    }>((result, { date, ...values }) => {
      const label = date;
      if (!result[label]) {
        result[label] = [];
      }
      result[label].push(values);
      return result;
    }, {});

    return {
      data: Object.keys(chartData).reduce<ChartData>((result, label) => {
        let value = 0;
        switch (type) {
          case EnumStatisticChartType.MARGINALITY_PERCENT:
            const sumSales = chartData[label].reduce<number>(
              //@ts-ignore поле там есть
              (r, { sale }) => sale,
              0
            );
            const sumPurchases = chartData[label].reduce<number>(
              //@ts-ignore поле там есть
              (r, { purchase }) => purchase,
              0
            );

            value =
              sumSales > 0 ? ((sumSales - sumPurchases) / sumSales) * 100 : 0;
            break;
          case EnumStatisticChartType.MARGINALITY_VALUTE:
            value = Math.round(
              chartData[label].reduce<number>((r, { value }) => value, 0)
            );
            break;
          default:
            value = chartData[label].reduce<number>((r, { value }) => value, 0);
            break;
        }
        result[label] = value;
        return result;
      }, {}),
      ...otherParams,
    };
  });
};
export default prepareChartData;
